import { edi } from '@/requests';
import { postRequest } from '@/core';

export default async function(tripId, subOrderId) {
	let url = edi.scheduleOrder(tripId, subOrderId);
	let response = await postRequest(url, {}, {});
	return response;
}